import { FormTransition } from './form-properties/form-transition';
import { FormState } from './form-properties/form-state';
import { FormMessage } from './form-properties/form-message';
import { FormGroup } from '@angular/forms';

export class FormBase {
  // common key for State and Transition Matrices
  stateID: any;

  // Form attributes
  FormActivateOnIE: string;
  FormCurrentState: any;
  FormValidUAID: any;
  FormInvalidUAID: any;
  FormCurrentUserActionID: string;
  FormTransitions: FormTransition[];
  FormStates: FormState[];
  FormMessages: FormMessage[];
  FormGroup: FormGroup;
  FormUXID: string;
}
